import guard from '../guard.js';
import parseToRgba from './parseToRgba.js';
import rgba from './rgba.js';

function transparentize(color, amount) {
  const [r, g, b] = parseToRgba(color);
  const guardedAmount = guard(0, 1, amount);
  return rgba(r, g, b, guardedAmount);
}

export { transparentize as default };
